import type { QChartTemplate } from "@coreapp/CoreApp/QChartTemplate";
import type { QChartTemplatesMgr } from "@coreapp/CoreApp/QChartTemplatesMgr";
import type { QBoxStylesManager } from "@coreapp/CoreApp/QBoxStylesManager";

type SerializedTemplate = ReturnType<QChartTemplate["SaveToJSON"]>;
type SerializedBoxStyles = ReturnType<QBoxStylesManager["SaveToJSON"]>;

type PastePayload = {
  templates: SerializedTemplate[];
  boxstyles: SerializedBoxStyles;
};

export function resolvePastePayload(content: string): PastePayload {
  const data = JSON.parse(content);

  if (!data || typeof data !== "object") {
    throw new Error("Invalid payload structure");
  }

  if (!Array.isArray(data.templates) || !Array.isArray(data.boxstyles)) {
    throw new Error("Invalid payload structure");
  }

  return {
    templates: data.templates,
    boxstyles: data.boxstyles
  };
}

export function buildCopyPayload(
  ctMgr: QChartTemplatesMgr,
  bsMgr: QBoxStylesManager
): PastePayload {
  const templates = ((ctMgr.fSharedTemplates ?? []) as QChartTemplate[]).map(template =>
    template.SaveToJSON()
  );
  const boxstyles = bsMgr.SaveToJSON(bsMgr.fSharedBoxStyles ?? []);

  return {
    templates,
    boxstyles
  };
}
